import React from 'react';
import blogs from '../../Blogs/blogs';
import BlogCard from './BlogCard';

const Blogs = () => {
    let key = 0;
    return (
        <section className="blog-container mt-5 pb-5 mw-100" id="blogs">
            <div data-aos="fade-up" className="caption mb-5" style={{ color: '#622aff' }}>Blogs</div>
            <div data-aos="fade-down" className="row d-flex justify-content-center flex-wrap mw-100 pl-5 pt-4 pb-4">
                {
                    blogs.map(blog => <BlogCard blog={blog} key={++key} />)
                }
            </div>
        </section>
    );
};

export default Blogs;